/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Extraction_In_ProgressInputs */

const en_audio_extraction_in_progress = /** @type {(inputs: Audio_Extraction_In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audio extraction in progress...`)
};

const fr_audio_extraction_in_progress = /** @type {(inputs: Audio_Extraction_In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extraction audio en cours...`)
};

const de_audio_extraction_in_progress = /** @type {(inputs: Audio_Extraction_In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audioextraktion läuft...`)
};

const it_audio_extraction_in_progress = /** @type {(inputs: Audio_Extraction_In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estrazione audio in corso...`)
};

const ru_audio_extraction_in_progress = /** @type {(inputs: Audio_Extraction_In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Процесс извлечения аудиофайлов продолжается...`)
};

const es_audio_extraction_in_progress = /** @type {(inputs: Audio_Extraction_In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extracción de audio en progreso...`)
};

const zh_cn2_audio_extraction_in_progress = /** @type {(inputs: Audio_Extraction_In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`音频提取正在进行中……`)
};

const ja_audio_extraction_in_progress = /** @type {(inputs: Audio_Extraction_In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オーディオ抽出中です...`)
};

const hi_audio_extraction_in_progress = /** @type {(inputs: Audio_Extraction_In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑडियो निकालने की प्रक्रिया जारी है...`)
};

const pt_pt2_audio_extraction_in_progress = /** @type {(inputs: Audio_Extraction_In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extração de áudio em andamento...`)
};

/**
* | output |
* | --- |
* | "Audio extraction in progress..." |
*
* @param {Audio_Extraction_In_ProgressInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_extraction_in_progress = /** @type {((inputs?: Audio_Extraction_In_ProgressInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Extraction_In_ProgressInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_extraction_in_progress(inputs)
	if (locale === "de") return de_audio_extraction_in_progress(inputs)
	if (locale === "it") return it_audio_extraction_in_progress(inputs)
	if (locale === "ru") return ru_audio_extraction_in_progress(inputs)
	if (locale === "es") return es_audio_extraction_in_progress(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_extraction_in_progress(inputs)
	if (locale === "ja") return ja_audio_extraction_in_progress(inputs)
	if (locale === "hi") return hi_audio_extraction_in_progress(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_extraction_in_progress(inputs)
	return en_audio_extraction_in_progress(inputs)
});